import React from 'react';

import { useIntl } from 'react-intl';

import { AppSubheader } from 'components/app-subheader';
import { useRoutesDisplayBottomService as useRoutesDisplayTopService } from 'components/bottom-service-mode/hooks/use-routes-display-bottom-service';
import { DeliveryBannerContainer } from 'components/delivery-banner';
import { TopServiceMode } from 'components/top-service-mode';
import { View } from 'components/view';
import { useMediaQuery } from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoadingIndicator } from 'state/loading';
import { useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';

import { HeaderContainer, NavBar, TopServiceModeContainer } from './styled';
import { StyledLoadingIndicator } from './styled-loading-indicator';

interface AppHeaderContainerProps {
  isInlineRewardDetailPage?: boolean;
}

export const AppHeaderContainer: React.FC<React.PropsWithChildren<AppHeaderContainerProps>> = (
  { children, ...rest },
  isInlineRewardDetailPage
) => {
  const { formatMessage } = useIntl();
  const { serviceMode, deliveryAddress } = useOrderContext();
  const isMobile = useMediaQuery('headerMobile');
  const LoadingIndicator = useLoadingIndicator();
  const { isStoreOpenAndAvailable } = useStoreContext();
  const showTopServiceOnRoutes = useRoutesDisplayTopService();
  const enableBottomServiceMode = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);
  const enableTopServiceMode =
    useFlag(LaunchDarklyFlag.ENABLE_TOP_SERVICE_MODE) && !enableBottomServiceMode;

  return (
    <View data-testid="app-header">
      <HeaderContainer {...rest}>
        <NavBar aria-label={formatMessage({ id: 'primaryNavLinks' })}>{children}</NavBar>
      </HeaderContainer>

      <StyledLoadingIndicator
        as={LoadingIndicator}
        hasStoreSelection={isStoreOpenAndAvailable && !enableBottomServiceMode}
      />

      {isMobile && enableTopServiceMode && showTopServiceOnRoutes && (
        <TopServiceModeContainer>
          <TopServiceMode />
        </TopServiceModeContainer>
      )}

      {!enableBottomServiceMode && !enableTopServiceMode && <DeliveryBannerContainer />}
      {!isInlineRewardDetailPage && (
        <AppSubheader serviceMode={serviceMode!} userAddress={deliveryAddress?.addressLine1} />
      )}
    </View>
  );
};
